import { BrowserRouter } from 'react-router-dom';
import Routes from 'routes';

import MainProvider from 'commons/providers/MainProvider';

import { FilterProvider, SearchProvider, SelectFigurantProvider, UserProvider } from 'commons/contexts';

import { CustomizedSnackbars } from 'components/modules';
import { Clarity } from 'libs';

import { QueryProvider } from 'commons/providers/QueryProvider';
import './config/firebase';

function App() {
  return (
    <MainProvider>
      <BrowserRouter>
        <QueryProvider>
          <UserProvider>
            <Clarity />
            <SelectFigurantProvider>
              <FilterProvider>
                <SearchProvider>
                  <Routes />
                </SearchProvider>
              </FilterProvider>
            </SelectFigurantProvider>
          </UserProvider>
          <CustomizedSnackbars />
        </QueryProvider>
      </BrowserRouter>
    </MainProvider>
  );
}

export default App;
